// extracted by mini-css-extract-plugin
export default {"servicos":"ServicosPage_servicos__8eYAr","servicosBox":"ServicosPage_servicosBox__7fwQT"};